import type { UseDiagnosedIcdsEditorReturn } from 'hooks/useDiagnosedIcdsEditor';
import { createEditorContext } from './createEditorContext';

const { Provider, useEditorContext } =
  createEditorContext<UseDiagnosedIcdsEditorReturn>('DiagnosedIcdsEditor');

export const DiagnosedIcdsEditorProvider = Provider;
export const useDiagnosedIcdsEditorContext = useEditorContext;
